import moment from "../../moment";

// 予約期限(発車45分前)を過ぎているかどうか判別する
export const isOverReservationLimit = (boardingDate, departureTime) => {
  // boardingDate: "YYYY-MM-DD", departureTime: "HH:MM"
  const dateNums = boardingDate.split("-");
  const timeNums = departureTime.match(/.{2}/g);
  const departureDateTime = new Date(
    parseInt(dateNums[0]),
    parseInt(dateNums[1]) - 1,
    parseInt(dateNums[2]),
    parseInt(timeNums[0]),
    parseInt(timeNums[1])
  );
  const limit = moment(departureDateTime).subtract(45, "m");
  const now = moment(new Date());
  return now.isAfter(limit);
};
